var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisibleEx,
            width: "1000px",
            "before-close": _vm.closeDialog,
            "close-on-click-modal": false,
            "custom-class": "sk-dialog",
            top: "2vh",
            title: "Gửi thông báo cho nhân sự",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisibleEx = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "createEmployeeNotify",
              attrs: {
                "label-width": "140px",
                model: _vm.createEmployeeNotify,
                "label-position": "left",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 40 } },
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c(
                      "div",
                      { staticClass: "grid-content" },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "Tiêu đề", prop: "sendTitle" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "Nhập tiêu đề" },
                              model: {
                                value: _vm.createEmployeeNotify.sendTitle,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.createEmployeeNotify,
                                    "sendTitle",
                                    $$v
                                  )
                                },
                                expression: "createEmployeeNotify.sendTitle",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "Nội dung", prop: "sendContent" } },
                          [
                            _c("el-input", {
                              attrs: {
                                rows: 15,
                                type: "textarea",
                                placeholder: "Nhập nội dung...",
                              },
                              model: {
                                value: _vm.createEmployeeNotify.sendContent,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.createEmployeeNotify,
                                    "sendContent",
                                    $$v
                                  )
                                },
                                expression: "createEmployeeNotify.sendContent",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "File đính kèm",
                              prop: "attachFile",
                            },
                          },
                          [
                            _c(
                              "el-upload",
                              {
                                ref: "upload",
                                attrs: {
                                  action: "",
                                  "on-remove": _vm.handleRemove,
                                  "before-remove": _vm.beforeRemove,
                                  "on-change": _vm.toggleUpload,
                                  "auto-upload": false,
                                  multiple: "",
                                  limit: 5,
                                  "on-exceed": _vm.handleExceed,
                                  "file-list": _vm.fileList,
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  { attrs: { size: "mini", type: "primary" } },
                                  [_vm._v("Tải lên")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "tab-infor-button sk-dialog-footer" },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-cancel",
                  attrs: { type: "danger", size: "medium" },
                  on: {
                    click: function ($event) {
                      return _vm.closeDialogByButton("createEmployeeNotify")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-close" }),
                  _c("span", [_vm._v("Đóng")]),
                ]
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn-save",
                  attrs: {
                    type: "success",
                    size: "medium",
                    loading: _vm.loadingButton,
                    mini: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("createEmployeeNotify")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-check" }),
                  _c("span", [_vm._v("Gửi")]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }